import { useEffect, useState } from "react";
import { toast } from "sonner";
import api, { fmtErr } from "../../lib/api";
import { PageHeader, EmptyState } from "../../components/bits";
import { BadgeCheck } from "lucide-react";

export default function PortalFortyHours() {
  const [data, setData] = useState(null);

  useEffect(() => {
    api.get("/portal/forty-hours").then((r) => setData(r.data)).catch((e) => toast.error(fmtErr(e)));
  }, []);

  if (!data) return <div className="text-center text-mutext py-20 font-head">جارٍ التحميل …</div>;

  return (
    <div data-testid="portal-forty-page" className="space-y-6">
      <PageHeader title="الطلاب متجاوزو 40 ساعة" sub="من أتم 40 ساعة تطوعية فأكثر من طلاب مدرستك — الاسم والصف وإجمالي الساعات" />

      <div className="bg-turq-600 text-white rounded-2xl p-5 text-center shadow-md max-w-xs">
        <div data-testid="portal-forty-total" className="font-head font-black text-3xl">{data.total}</div>
        <div className="text-xs font-bold opacity-90 mt-1">طالباً أتم 40 ساعة فأكثر</div>
      </div>

      <div className="bg-surface rounded-2xl border border-brd shadow-md overflow-hidden">
        <div className="max-h-[520px] overflow-auto">
          <table className="w-full text-xs">
            <thead className="sticky top-0 z-10">
              <tr className="bg-turq-900 text-white">
                <th className="text-right px-3 py-2.5">#</th>
                <th className="text-right px-3 py-2.5">الاسم</th>
                <th className="text-right px-3 py-2.5">الصف</th>
                <th className="text-right px-3 py-2.5">إجمالي الساعات</th>
                <th className="text-right px-3 py-2.5">الإنجاز</th>
              </tr>
            </thead>
            <tbody>
              {data.students.map((s, i) => (
                <tr key={i} data-testid={`portal-forty-row-${i}`} className="border-t border-brd/50 hover:bg-beige-300/50 dark:hover:bg-surface2 transition-colors">
                  <td className="px-3 py-2 text-mutext">{i + 1}</td>
                  <td className="px-3 py-2 font-bold">{s.name}</td>
                  <td className="px-3 py-2">{s.grade}</td>
                  <td className="px-3 py-2"><b className="text-coral-600">{s.hours}</b> ساعة</td>
                  <td className="px-3 py-2">
                    <span className="inline-flex items-center gap-1 rounded-full bg-turq-100 dark:bg-surface2 text-turq-900 dark:text-turq-300 text-[10px] font-bold px-2.5 py-1">
                      <BadgeCheck className="w-3 h-3" /> أنجز 40 ساعة
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          {data.students.length === 0 && <EmptyState testid="portal-forty-empty" text="لا يوجد طلاب متجاوزون لـ 40 ساعة بعد" />}
        </div>
      </div>
    </div>
  );
}
